'use strict';

angular.module('DoohApps').service('User', ['$window', '$route', 'Hub', 'gettextCatalog', 'Constants', 'SessionHelper',
    function UserService($window, $route, Hub, gettextCatalog, Constants, SessionHelper) {
        //Object.assign is used instead of assignment to keep object reference since this has to be exposed to $scope.
        //E.g. by doing `user = newUser;`, will break the reference between $scope variable and service's variable.
        let user = this;
        let emptyUser = { company: {}, accessRights: {}, companiesAccesses: [], isLoggedIn: false, language: Constants.defaultLanguageISOCode };

        Object.assign(user, emptyUser);
        this.setUser = setUser;

        setUser();

        //DOOH-1590 - set last active user settings
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                if (user.accessToken !== SessionHelper.GetAccessToken()) { //either accessToken has expired or user logged in with different account
                    SessionHelper.setUserCompany();
                    setUser();
                    setAccessToken(SessionHelper.GetAccessToken());
                    $window.location.reload();
                }
                else
                    saveToStorage();
            }
        });

        function setUser(newUser) {
            newUser = newUser || JSON.parse(localStorage.getItem('user')) || emptyUser;
            Object.assign(user, newUser);
            user.company = SessionHelper.getUserCompany() || user.company;
            user.accessToken = SessionHelper.GetAccessToken();
            saveToStorage();

            user.updateDetails = updateDetails;
            user.updatePicture = updatePicture;
            user.updateLogo = updateLogo;
            user.changeLanguage = changeLanguage;
            user.switchCompany = switchCompany;
            user.updateCompany = updateCompany;
            user.clear = clear;
            user.hasAccess = hasAccess;
            user.validateAccessRightParameter = validateAccessRightParameter;
        }

        function updateDetails(details) {
            user.firstName = details.firstName;
            user.lastName = details.lastName;
            user.useLocalTime = details.useLocalTime;
            saveToStorage();
        }

        function updatePicture(url) {
            user.imageURL = url;
            saveToStorage();
            return url;
        }

        function updateLogo(url) {
            user.logoURL = url;
            saveToStorage();
            return url;
        }

        function changeLanguage() {
            gettextCatalog.setCurrentLanguage(user.language);
            gettextCatalog.loadRemote('Scripts/translations/languages/' + user.language + '.json');
            saveToStorage();
        }

        function switchCompany(company) {

            company = company || user.company;
            if (!company) {
                void 0;
                location.reload();
                return; // EBX hotfix
            }

            Object.assign(user.company, company);
            saveToStorage();
            Hub.Stop();
            $route.reload();
            Hub.Start(user.company.id, user.id);
        }

        function updateCompany(company) {
            let userAccessCompany = user.companiesAccesses.find(accessCompany => accessCompany.id === company.id);
            if (userAccessCompany !== null) {
                Object.assign(userAccessCompany, company);
                user.companiesAccesses.sort();
            }
            if (user.company.id === company.id)
                Object.assign(user.company, company);
            saveToStorage();
        }

        function saveToStorage() {
            //Save only user data in localStorage
            var newUser = Object.assign({}, user);
            Object.keys(newUser).forEach(prop => {
                if (typeof newUser[prop] === 'function')
                    delete newUser[prop];
            })
            localStorage.setItem('user', JSON.stringify(newUser));

            SessionHelper.setUserCompany(newUser.company);
        }

        function clear() {
            //Clear all properties except methods
            Object.keys(user).forEach(prop => {
                if (typeof user[prop] !== 'function')
                    delete user[prop];
            })
            Object.assign(user, emptyUser);
            saveToStorage();
        }

        function hasAccess(accessRight) {
            return user.accessRights !== undefined && user.accessRights[accessRight] !== undefined;
        }

        function validateAccessRightParameter(accessRight, parameter) {
            return user.accessRights && user.accessRights[accessRight] && (user.accessRights[accessRight] === parameter || user.accessRights[accessRight][0] === parameter);
        }


        function setAccessToken(token) {
            user.accessToken = token;
            saveToStorage();
        }
    }]);